import { render, staticRenderFns } from "./DidYouKnow.vue?vue&type=template&id=11848b84&"
import script from "./DidYouKnow.vue?vue&type=script&lang=js&"
export * from "./DidYouKnow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports